export function CheckInteger(e: KeyboardEvent) {
  if (e.key && !e.key.match(/[0-9]+/)) {
    e.preventDefault();
  }
}
